import { IMAGES } from "../lib/restaurant";
import { useLang } from "../i18n/LanguageContext";

const TILES = [
  { key: "heroEvening",  span: "col-span-12 md:col-span-8 row-span-2 aspect-[16/10] md:aspect-auto" },
  { key: "muralDay",     span: "col-span-12 md:col-span-4 aspect-[4/5]" },
  { key: "bar",          span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "pasta",        span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "tiramisu",     span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "interiorBar",  span: "col-span-12 md:col-span-7 aspect-[16/10]" },
  { key: "aperi",        span: "col-span-12 md:col-span-5 aspect-[4/3]" },
  { key: "signage",      span: "col-span-12 md:col-span-5 aspect-[4/3]" },
  { key: "menuTable",    span: "col-span-12 md:col-span-7 aspect-[16/10]" },
  { key: "bar2",         span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "awards1",      span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "awards2",      span: "col-span-6 md:col-span-4 aspect-square" },
  { key: "terrace",      span: "col-span-6 md:col-span-6 aspect-[4/3]" },
  { key: "entry",        span: "col-span-12 md:col-span-6 aspect-[4/3]" },
  { key: "logo",         span: "col-span-12 md:col-span-4 aspect-square bg-charcoal" },
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <div data-testid="gallery-page" className="pt-20 bg-cream">
      <section className="bg-charcoal text-cream py-24 sm:py-28">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12">
          <p className="uppercase-track text-xs text-gold mb-6">{t.gallery.eyebrow}</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mb-6">
            {t.gallery.title1} <span className="italic text-gold">{t.gallery.title2}</span> {t.gallery.title3}
          </h1>
          <p className="text-cream/85 text-lg max-w-2xl leading-relaxed">{t.gallery.text}</p>
        </div>
      </section>

      <section className="py-10">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 flex flex-wrap gap-3 pb-10 border-b border-charcoal/10">
          {t.gallery.tags.map((c, i) => (
            <span key={c} data-testid={`gallery-tag-${i}`} className="text-xs uppercase-track px-4 py-2 border border-charcoal/30 text-charcoal/70 hover:bg-charcoal hover:text-cream transition cursor-default">
              {c}
            </span>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-10">
          <div className="grid grid-cols-12 gap-3 sm:gap-4">
            {TILES.map((tile, i) => (
              <div key={i} className={`relative group overflow-hidden ${tile.span}`} data-testid={`gallery-tile-${i}`}>
                <img
                  src={IMAGES[tile.key]}
                  alt=""
                  className={`w-full h-full ${tile.key === "logo" ? "object-contain p-6" : "object-cover"} transition-transform duration-700 group-hover:scale-105`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
